import { useQuery } from '@tanstack/vue-query';

import { ACCESS_TOKEN_STORAGE_KEY } from '~/constants';
import localstorage from '~/foundation/storage/localstorage';
import keycloackApi from '~/services/keycloack-api/keycloack-api';
import personApi from '~/services/person-api/person-api';

import { queryKeys } from '../queryClient';

export default function useAuth() {
  const queryKey = queryKeys.AUTH.STATUS;

  const queryFn = async () => {
    const token = localstorage.get<string>(ACCESS_TOKEN_STORAGE_KEY);
    if (token) {
      const keycloack = await keycloackApi.getUserInfo();
      const person = await personApi.whoAmI(keycloack.sub);

      return {
        keycloack,
        person,
      };
    }
    throw new Error('UNAUTHENTICATED');
  };

  return useQuery({
    queryFn,
    queryKey,
    refetchInterval: 1000 * 15, // 15 seconds
    retry: false,
    staleTime: 1000 * 60 * 1, // 1 minute
  });
}
